<template>
  <div main>
    <slider type="main" :option="{autoplay: { delay: 5000 }, mousewheel: true}">
      <li class="swiper-slide">
        <img src="/static/img/main/mobile_bg_2.png" class="m-img">
        <div style="background-image: url(/static/img/main/pc_bg_2.png)" class="pc-img"></div>
        <router-link to="/about" class="hidden-lg-up"></router-link>
        <router-link to="/about" class="hidden-md-down" data-pos="126,667"></router-link>
      </li>
      <li class="swiper-slide">
        <img src="/static/img/main/mobile_bg_3.png" class="m-img">
        <div style="background-image: url(/static/img/main/pc_bg_3.png)" class="pc-img"></div>
        <router-link to="/counseling" class="hidden-lg-up"></router-link>
        <router-link to="/counseling" class="hidden-md-down" data-pos="126,667"></router-link>
      </li>
      <li class="swiper-slide">
        <img src="/static/img/main/mobile_bg_4.png" class="m-img">
        <div style="background-image: url(/static/img/main/pc_bg_4.png)" class="pc-img"></div>
<!--        <a class="hidden-lg-up open-video"></a>-->
<!--        <a class="hidden-md-down open-video" data-pos="126,667"></a>-->
      </li>
    </slider>
    <sns class="hidden-md-down" />
    <popup v-if="mov">
      <div class="tb">
        <div class="cell">
          <div class="play">
            <img src="/static/img/common/fhd.png" alt="">
            <iframe src="https://www.youtube.com/embed/Zol7vWuOnS4?rel=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
            <div class="close" @click="mov = false"></div>
          </div>
        </div>
      </div>
    </popup>
    <div class="popup-20190621" v-if="popup01" @click="popup01 = false">
      <div class="holder">
        <a href="http://maps.gynpad.com/map/gynpad_store2.asp" target="_blank">
          <img src="/static/img/main/gs_popup.png" class="img"/>
        </a>
        <img src="/static/img/main/gs_popup_close.png" class="close">
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  @import "../less/gynpad";
  @import "../less/asset";

  [main] { .rp(0,12,12,12); .border-box; .wf;
    [slider] {
      .swiper-slide { overflow: hidden;
        .m-img { width: 100%; }
        .pc-img { .hide; }
        .hidden-lg-up { .lt(8.666%, 38.998%); .wh(12.166%, 7.171%); }
        .hidden-md-down { .abs; }
      }
    }
    .tb { display: table; width:100%; height:100vh;
      .cell { display: table-cell; .tc; .vam; padding: 10px; .border-box;
        .play { .ib; .rel;
          img { max-width: 100%; max-height:calc(~"100vh - 20px"); }
          iframe { .lt; .wh(100%); }
          .close { .contain('@{common}/close_w.svg'); .wh(20px); .rt(0, -30px); }
        }
      }
    }
    [sns] { z-index: 10; bottom:120px;}
    .popup-20190621 { .fix; .f; background: rgba(0,0,0,0.7); z-index: 10000; left:0; top:0;
      .holder { .abs; .lt(50%,50%);  transform: translateX(-50%) translateY(-50%);
        .img { .block; max-width: 90vw; }
        .close { .abs; .rt(0, -40px); }
      }

    }
  }

  @media (min-width: @screen-lg-min) {
    [main] { height:100vh; padding:20px;
      [slider] {
        .swiper-slide {
          .m-img { .hide; }
          .pc-img { .block; height: calc(~"100vh - 40px"); .cover; .bg-c; }
        }
      }
      .tb {
        .cell { padding: 60px;
          .play {
            img { max-height:calc(~"100vh - 120px"); }
            .close { .contain('@{common}/close_w.svg'); .wh(30px); .rt(0, -40px); }
          }
        }
      }
      .popup-20190621 {
        .holder {
          .close { .abs; .rt( -40px, 0); }
        }

      }
    }
  }
</style>

<script>
import _ from 'lodash';
import Slider from '../components/Slider.vue';
import Popup from '../components/Pop.vue';
import Sns from '../components/Sns.vue';

export default {
  name: 'Main',
  components: { Slider, Popup, Sns },
  data() {
    return {
      mov: false,
      popup01: true,
    };
  },
  mounted() {
    window.addEventListener('resize', this.resize);
    this.resize();
    this.$el.addEventListener('click', this.checkOpenVideo);
  },
  beforeDestroy() {
    this.$el.removeEventListener('click', this.checkOpenVideo);
  },
  methods: {
    checkOpenVideo(e) {
      if (window.$(e.target).hasClass('open-video')) {
        this.mov = true;
      }
    },
    resize() {
      const rect = this.$el.querySelector('.swiper-container');
      const w = rect.offsetWidth;
      const h = rect.offsetHeight;
      const r = Math.max(w / 1880, h / 1040);
      const psW = 1880 * r;
      const psH = 1040 * r;
      const psL = (w - psW) * 0.5;
      const psT = (h - psH) * 0.5;

      _.forEach(this.$el.querySelectorAll('.swiper-slide .hidden-md-down'), (e) => {
        const t0 = e.getAttribute('data-pos').split(',');
        const ox = t0[0];
        const oy = t0[1];
        e.style.width = `${80 * r}px`;
        e.style.height = `${80 * r}px`;
        e.style.left = `${(ox * r) + psL}px`;
        e.style.top = `${(oy * r) + psT}px`;
      });
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/views/Main.vue